import React from 'react';
import { motion } from 'framer-motion';
import { CTAButton } from './ui/CTAButton';
import { trackAddToCart } from '../utils/metaPixel';
export function OfferBlock() {
  return <section id="offer" className="py-16 md:py-24 px-6 bg-brand-card relative overflow-hidden" data-id="element-101">
      {/* Background glow */}
      <div className="absolute bottom-0 left-1/2 -translate-x-1/2 w-full max-w-2xl h-64 bg-brand-accent/10 blur-[120px] rounded-full pointer-events-none" aria-hidden="true" data-id="element-102" />

      <div className="max-w-4xl mx-auto relative z-10" data-id="element-103">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8
      }} className="bg-brand-surface border-2 border-brand-accent rounded-2xl p-8 md:p-16 text-center shadow-[0_0_50px_rgba(212,160,23,0.15)]" data-id="element-104">
          <h2 className="font-heading font-extrabold text-4xl md:text-5xl text-brand-text uppercase leading-tight mb-4" data-id="element-105">
            Recupera el mando de tu cuerpo{' '}
            <span className="text-brand-accent" data-id="element-106">hoy mismo</span>
          </h2>

          <p className="font-body text-xl text-brand-muted mb-10" data-id="element-107">
            Por el precio de una cena afuera, obtén el sistema completo para
            transformar tu energía para siempre.
          </p>

          <div className="mb-10" data-id="element-108">
            <span className="block font-heading font-bold text-xl text-brand-muted uppercase tracking-widest mb-3" data-id="element-109">
              Oferta Especial
            </span>
            <div className="flex items-center justify-center gap-4 mb-2" data-id="element-110">
              <span className="font-heading font-bold text-3xl md:text-5xl text-brand-muted line-through opacity-50" data-id="element-111">
                $27
              </span>
              <span className="bg-brand-red text-brand-text font-heading font-bold text-sm md:text-base uppercase tracking-wider px-3 py-1 rounded-md" data-id="element-112">
                -76% OFF
              </span>
            </div>
            <span className="font-heading font-extrabold text-6xl md:text-8xl text-brand-accent drop-shadow-lg" data-id="element-113">
              $6.39{' '}
              <span className="text-3xl md:text-5xl text-brand-text" data-id="element-114">USD</span>
            </span>
          </div>

          <div className="flex flex-col items-center gap-4" data-id="element-115">
            <CTAButton href="https://guiasparavivir.com/cart/52458895966497:1" onClick={trackAddToCart} className="w-full md:w-auto md:px-12 md:py-6 md:text-2xl shadow-[0_0_30px_rgba(212,160,23,0.4)] hover:shadow-[0_0_50px_rgba(212,160,23,0.6)]" data-id="element-116">
              Acceder al Protocolo Varonil 45+ Ahora
            </CTAButton>

            <p className="font-body text-sm md:text-base text-brand-muted mt-4 flex items-center justify-center gap-2" data-id="element-117">
              <span className="w-2 h-2 rounded-full bg-brand-green animate-pulse" aria-hidden="true" data-id="element-118" />
              Recibe descarga inmediata y comienza tu transformación hoy mismo.
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}